import { render, staticRenderFns } from "./report-field.vue?vue&type=template&id=53ff046b&scoped=true&"
import script from "./report-field.vue?vue&type=script&lang=js&"
export * from "./report-field.vue?vue&type=script&lang=js&"
import style0 from "./report-field.vue?vue&type=style&index=0&id=53ff046b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff046b",
  null
  
)

export default component.exports